// CSV cell encoding shared by every CSV export (API + SPA).
//
// Besides RFC 4180 quoting, this neutralizes spreadsheet formula injection:
// a text cell starting with = + - @ (or tab / CR) would be evaluated as a
// formula when the file is opened in Excel, so exported names or notes like
// `=HYPERLINK(...)` could exfiltrate data or run commands. Such cells get a
// leading apostrophe. Plain numbers (e.g. "-125.40") pass through unchanged
// so negative amounts stay numeric.

const FORMULA_TRIGGER = /^[=+\-@\t\r]/;
const PLAIN_NUMBER = /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/;

export function csvCell(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'number' || typeof value === 'bigint') return String(value);
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  let s = String(value);
  if (FORMULA_TRIGGER.test(s) && !PLAIN_NUMBER.test(s)) s = `'${s}`;
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}
